import request from '@/utils';

const prefix = '/sson';

// 获取需求申请列表
export async function getSourceDemandList(params: any) {
  return request.post('/todo/check/moa', params);
}

// 创建同事辅助认证审批流
export async function createVerification(params: any) {
  return request.post('/associateassisted/verification', params, prefix);
}

// 轮询同事辅助认证审批结果
export async function checkAssociateAssistedResult(params: any) {
  return request.post(
    '/associateassisted/verification/polling',
    params,
    prefix
  );
}

// 获取同事辅助认证邀请人审批邀请信息
export async function getVerificationInfo(params: any) {
  return request.post('/associateassisted/verification/info', params, prefix);
}

// 审批同事辅助认证审批流
export async function verificationApprove(params: any) {
  return request.post(
    '/associateassisted/verification/approve',
    params,
    prefix
  );
}

// 同事辅助认证审批流状态查询
export async function getVerificationStatus(params: any) {
  return request.post(
    '/associateassisted/verification/approve/status',
    params,
    prefix
  );
}

// 获取同事辅助认证邀请邀请策略
export async function getInviteStrategy(params: any) {
  return request.post('/associateassisted/strategy', params, prefix);
}

// 获取同事辅助认证邀请人相关信息
export async function getInvitorInfo(params: any) {
  return request.post('/associateassisted/invitor/info', params, prefix);
}

// 获取Native待办事项列表详情
export async function getToDoList(params: any) {
  return request.post('/todo/list/native/check', params, prefix);
}
